/**
 * Created by luissalcedo on 1/18/17.
 */
export class User{
  constructor(
    public $key : string,
    public first  : string,
    public isActive   : boolean,
    public last   : string,
    public nickName   : string,
    public sysUid     : string,
    public urlPicture : string,
    public edit : string,
    public email : string

  ){};

  // TODO : Add picture url

  static fromJsonList(array): User[]{

    return array.map(json => User.fromJson(json));

  }

  static fromJson( {$key,first,isActive,last,nickName,sysUid,urlPicture,edit,email}) : User {
    return new User($key,first,isActive,last,nickName,sysUid,urlPicture,edit,email)
  }





}



// WEBPACK FOOTER //
// ./src/app/shared/model/user.ts